/** @format */
// HeaderSearchBar.jsx
import { FaSearch, FaWhatsapp } from "react-icons/fa";
import { phone } from "../../utils/utils";

const HeaderSearchBar = ({
  t,
  categories,
  category,
  setCategory,
  searchValue,
  setSearchValue,
  handleSearch,
}) => {
  return (
    <div className='w-9/12 pl-8 md-lg:pl-0 md-lg:w-full'>
      <div className='flex flex-nowrap w-full justify-between items-center gap-4 md-lg:gap-5'>
        {/* Search Input */}
        <div className='md-lg:w-full w-8/12'>
          <div
            className='flex items-center h-[52px] rounded-md overflow-hidden
                        bg-white border border-slate-200
                        shadow-[0_2px_16px_rgba(0,0,0,0.07)]
                        focus-within:shadow-[0_2px_24px_rgba(37,99,235,0.18)]
                        focus-within:border-blue-400
                        transition-all duration-300 ease-in-out'
          >
            {/* Category Select */}
            <div className='relative flex items-center h-full md:hidden shrink-0'>
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className='h-full pl-4 pr-8 text-slate-600 text-sm font-semibold
                           bg-slate-50 border-r border-slate-200
                           outline-none cursor-pointer
                           appearance-none
                           hover:bg-slate-100 transition-colors duration-200
                           min-w-[150px]'
                style={{ backgroundImage: "none" }}
              >
                <option value=''>{t("Select Category")}</option>
                {categories.map((cat, index) => (
                  <option key={index} value={cat.name}>
                    {cat.name}
                  </option>
                ))}
              </select>
              {/* Custom chevron */}
              <span className='pointer-events-none absolute right-2 text-slate-400'>
                <svg
                  width='14'
                  height='14'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='2.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                >
                  <polyline points='6 9 12 15 18 9' />
                </svg>
              </span>
            </div>

            {/* Text Input */}
            <input
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSearch()}
              type='text'
              placeholder={t("What do you need")}
              className='flex-1 h-full px-4 text-slate-700 placeholder:text-slate-400
                         text-sm bg-transparent outline-none'
            />

            {/* Search Button */}
            <button
              onClick={handleSearch}
              className='h-full px-6 flex items-center justify-center gap-2
                         bg-blue-600 hover:bg-blue-700 active:bg-blue-800
                         text-white text-sm font-semibold
                         transition-all duration-200 ease-in-out
                         group shrink-0'
            >
              <FaSearch className='text-base transition-transform duration-200 group-hover:scale-110' />
              <span className='hidden sm:inline tracking-wide uppercase text-xs font-bold'>
                {t("Search")}
              </span>
            </button>
          </div>
        </div>

        {/* WhatsApp Contact */}
        <div className='w-4/12 block md-lg:hidden pl-2 md-lg:w-full md-lg:pl-0'>
          <a
            href={`https://wa.me/${phone}`}
            className='flex justify-end items-center gap-3 group'
          >
            <div
              className='w-[46px] h-[46px] rounded-full flex items-center justify-center
                          bg-green-50 border border-green-100
                          group-hover:bg-green-500 group-hover:border-green-500
                          transition-all duration-250 ease-in-out shadow-sm'
            >
              <FaWhatsapp className='text-green-500 text-xl group-hover:text-white transition-colors duration-250' />
            </div>
            <div className='flex flex-col gap-[2px]'>
              <span className='text-[13px] font-bold text-green-500 leading-tight tracking-tight'>
                +{phone}
              </span>
              <span className='text-[12px] text-slate-500 font-medium leading-tight'>
                {t("Support 7/24 time")}
              </span>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeaderSearchBar;
